





















import Vue from 'vue'

export default Vue.extend({
	props: {
		options: {
			type: [Array, Object],
			required: true,
		},
		placeholder: {
			type: String,
			default: 'Please select an item',
		},
		closeOnOutsideClick: {
			type: [Boolean],
			default: true,
		},
		full: {
			type: Boolean,
			default: false,
		},
		round: {
			type: Boolean,
			default: false,
		},
		search: {
			type: Boolean,
			default: false,
		},
		top: {
			type: Boolean,
			default: false,
		},
		value: {
			type: [String, Number],
			default: null,
		},
	},
	data() {
		return {
			selectedOption: <any> {
				name: '',
			},
			showMenu: false,
			placeholderText: 'Please select an item',
		}
	},
	watch: {
		value() {
			if (this.value) {
				this.options.forEach((opt: any) => {
					if (String(opt.value) === String(this.value)) {
						this.selectedOption = opt
					}
				})
			}
		},
		options() {
			if (this.value !== null) {
				this.options.forEach((opt: any) => {
					if (String(opt.value) === String(this.value)) {
						this.selectedOption = opt
					}
				})
			}
		},
	},
	mounted() {
		if (this.value !== null) {
			this.options.forEach((opt: any) => {
				if (String(opt.value) === String(this.value)) {
					this.selectedOption = opt
				}
			})
		}

		if (this.placeholder) {
			this.placeholderText = this.placeholder
		}

		if (this.closeOnOutsideClick) {
			document.addEventListener('click', this.clickHandler)
		}
	},
	beforeDestroy() {
		document.removeEventListener('click', this.clickHandler)
	},
	methods: {
		updateOption(option: any) {
			this.selectedOption = option
			this.showMenu = false
			this.$emit('input', this.selectedOption.value)
		},
		toggleMenu() {
			this.showMenu = !this.showMenu
		},
		clickHandler(event: any) {
			const { target } = event
			const { $el } = this

			if (!$el.contains(target)) {
				this.showMenu = false
			}
		},
	},
})
